import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../features/login/loginSlice";
import { selectAccounts } from "../../features/manageAccounts/accountsSlice";
import { clearNewTransaction, selectNewTransaction } from "../../features/transactionList/transactionsSlice";
import { resetTransferForm, selectTransferAmount, selectTransferFrom, selectTransferTo, setTransferConfirming } from "../../features/transfer/transferSlice";
import { useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import { selectUser } from "../../features/home/userSlice";

export default function TransferConfirmation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loggedIn = useSelector(isLoggedIn);
    const accounts = useSelector(selectAccounts);
    const newTransaction = useSelector(selectNewTransaction);
    const transferFrom = useSelector(selectTransferFrom);
    const transferTo = useSelector(selectTransferTo);
    const transferAmount = useSelector(selectTransferAmount);

    const userInfo = useSelector(selectUser);    
    const bankId = userInfo.bankId;

    let month;
    let day;
    let year;
    if (newTransaction.id) {
        let transactionDate = newTransaction.transactionDate.split("T")[0].split("-");
        month = transactionDate[1];
        day = transactionDate[2];
        year = transactionDate[0];
    }

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    const handleClick = () => {
        dispatch(clearNewTransaction());
        dispatch(resetTransferForm());
        dispatch(setTransferConfirming(false));
        navigate(`../${bankId}/transfer`);
    }

    return (
        <main>
            <Sidebar />
            {!newTransaction.id ? "" : 
                <section>
                    <h2>Transfer Confirmation</h2>
                    <h3><span>Transfer From:</span> {Object.values(accounts).find(account => account.accountId === transferFrom.value).accountType} {transferFrom.value}</h3>
                    <h3><span>Transfer To:</span> {Object.values(accounts).find(account => account.accountId === transferTo.value).accountType} {transferTo.value}</h3>
                    <h3><span>Amount:</span> ${Number(transferAmount).toFixed(2)}</h3>
                    <h3><span>Transaction Date:</span> {`${month}/${day}/${year}`}</h3>
                    <h3><span>Transaction Id:</span> {newTransaction.id}</h3>
                    <button onClick={handleClick}>Make Another Transfer</button>    
                </section>}
        </main>
    )
}
